export enum IssueType {
  // eslint-disable-next-line no-unused-vars
  ISSUE_API = 'ISSUE_API',
  // eslint-disable-next-line no-unused-vars
  COPY_BY_POLICY_ID = 'COPY_BY_POLICY_ID',
}

export interface Coupon {
  policyId: string;
  name: string;
  minOrderAmount: string;
  maxDiscountAmount: string;
  validityPeriod: string;
  maxCouponsPerUser: number;
  available: boolean;
  received?: number;
  issueType?: IssueType;
  remaining: number | null;
}

export interface AccessMetrics {
  latestViewers: string[];
}

export interface ClickingMetric {
  latestViewers: string[];
  userCount: number;
}

export interface ClickingMetrics {
  products: { [key: string]: ClickingMetric };
}

export interface SocialInfo {
  accessMetrics: AccessMetrics;
  clickingMetrics: ClickingMetrics;
}
